var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./AddTraining.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4e15cd2c!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AddTraining.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Trainings/Add/AddTraining.vue
// module id = 662
// module chunks = 0